<template>
  <div class="tofeel-container">
    <div class="tofeel-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/tofeel-banner.png"
        alt=""
      />
      <div class="banner-wordbox">
        <div class="banner-wordbox-content">
          <h2 class="banner-title">感知图书馆解决方案</h2>
          <p class="banner-desc">感知图书馆借助博库微信端图书馆集成服务平台</p>
          <p class="banner-desc">
            帮助公共图书馆实现图书馆的“泛在化”，使读者不受时间、空间、地域的限制
          </p>
          <p class="banner-desc">
            可以随时随地接触到图书馆的资源，享受到图书馆的服务
          </p>
        </div>
      </div>
    </div>
    <!-- 感知大数据 -->
    <div class="tofeel-container-feelBigdata">
      <h2 class="tofeel-container-feelBigdata-title title-common">
        感知大数据
      </h2>
      <div class="tofeel-container-feelBigdata-content">
        <div class="tofeel-container-feelBigdata-content-pics">
          <div
            class="tofeel-container-feelBigdata-content-pics-box"
            v-for="(item, i) in bigData"
            :key="i"
          >
            <img :src="item.img" alt="" />
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="tofeel-container-feelBigdata-content-dot1">
          <div class="tofeel-container-feelBigdata-content-dot1-pulse"></div>
        </div>
        <div class="tofeel-container-feelBigdata-content-dot2">
          <div class="tofeel-container-feelBigdata-content-dot2-pulse"></div>
        </div>
      </div>
    </div>
    <!-- 管理感知 -->
    <div class="tofeel-container-manage">
      <h2 class="tofeel-container-manage-title title-common">
        管理感知
      </h2>
      <div class="tofeel-container-manage-content">
        <div class="tofeel-container-manage-content-left">
          <img :src="manageList[current].img" alt="" />
        </div>
        <div class="tofeel-container-manage-content-right">
          <ul>
            <li
              v-for="(item, i) in manageList"
              :key="i"
              @click="current = i"
              :class="{ liActive: current == i }"
            >
              <img
                src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-icon.png"
                alt=""
                v-if="current == i"
              />
              <h3 :class="{ liActive: current == i }">{{ item.title }}</h3>
              <p :class="{ liActive: current == i }">
                {{ item.introduction }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 服务感知 -->
    <div class="tofeel-container-service">
      <h2 class="tofeel-container-service-title title-common">
        服务感知
      </h2>
      <div class="tofeel-container-service-content">
        <div class="tofeel-container-service-content-bg">
          <img
            src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-girl.png"
            alt=""
          />
        </div>
        <img
          src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-focus.png"
          alt=""
          class="tofeel-container-service-content-focus"
        />
        <img
          src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-info-fix.png"
          alt=""
          class="tofeel-container-service-content-info"
        />
      </div>
    </div>
    <!-- 智能设备感知服务 -->
    <div class="tofeel-container-smart">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-smart.png"
        alt=""
      />
      <div class="tofeel-container-smart-right">
        <h3>全自助化服务，简单、快速、高效</h3>
        <p>自助服务设备通过人脸识别技术可感知读者的身份和操作</p>
        <p>读者无需读者证和手机，也能享受快捷借还书服务</p>
        <p>系统还将实时分析读者借阅行为和数据</p>
        <p>更新用户多维度画像模型</p>
      </div>
      <img
        src="https://image.bookgo.com.cn/bgOfficial/aboutus/about-bubble-left.png"
        alt=""
        class="tofeel-container-smart-bubble"
      />
    </div>
    <!-- 安全感知 -->
    <div class="tofeel-container-safety">
      <h2 class="tofeel-container-safety-title title-common">
        安全感知
      </h2>
      <div class="tofeel-container-safety-tab">
        <ul>
          <li @click="isActive = true" :class="{ tabActive: isActive }">
            天网系统黑名单监测
          </li>
          <li @click="isActive = false" :class="{ tabActive: !isActive }">
            用户轨迹跟踪
          </li>
        </ul>
        <img
          src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-safety1.png"
          alt=""
          class="tofeel-container-safety-tab-pic1"
          v-if="isActive"
        />
        <img
          src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-safety2.png"
          alt=""
          class="tofeel-container-safety-tab-pic2"
          v-if="!isActive"
        />
      </div>
    </div>
    <!-- 空间感知 -->
    <div class="tofeel-container-space">
      <h2 class="tofeel-container-space-title title-common">空间感知</h2>
      <div class="tofeel-container-space-content">
        <p>依托室内定位技术和三维地图导航技术</p>
        <p>读者在找书过程中，系统实时定位读者准确位置</p>
        <p>并提供三维立体动态导航路径</p>
        <p>读者还能以全局视角俯览整个图书馆的位置和空间分布</p>
        <p>让读者寻书不再绕路。</p>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="tofeel-container-advantange">
      <h2 class="tofeel-container-advantange-title title-common">
        方案优势
      </h2>
      <ul class="tofeel-container-advantange-list">
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-list-item1.png"
            alt=""
          />
          <h3>全面无卡化服务</h3>
          <p>利用感知数据模型 为读者提供全程无卡化服务</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-list-item2.png"
            alt=""
          />
          <h3>读者多维画像</h3>
          <p>
            为读者的个人画像实时统计分析 与图书馆大数据结合，推出个性化服务体验
          </p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-list-item3.png"
            alt=""
          />
          <h3>安全化服务</h3>
          <p>
            通过人防、物防、技防等手段 全天候无死角监测图书馆，保障图书馆安全
          </p>
        </li>
      </ul>
    </div>
    <toTop />
  </div>
</template>

<script>
import toTop from "@/assets/components/toTop";
export default {
  components: { toTop },
  data() {
    return {
      current: 0,
      isActive: true,
      manageList: [
        {
          title: "人流管控系统",
          introduction:
            "通过智能闸机对出入人群的数量控制，来达到人流管控的目的，避免内部人流拥挤",
          img:
            "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-manage1.png",
        },
        {
          title: "区域性人流感知系统",
          introduction:
            "通过不同区域的智能监控的视频数据，后台实时分析读者人群画像属性与当前区域进行对比",
          img:
            "https://image.bookgo.com.cn/bgOfficial/tofeel/toFeel-index-tab.jpg",
        },
        {
          title: "人流热力图",
          introduction:
            "通过智能监控和智能wifi系统，来识别监测图书馆内人流的分布图",
          img:
            "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-index-hot.png",
        },
      ],
      bigData: [
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item1.png",
          title: "到馆统计分布",
          desc: "到馆统计读者人数今日和昨日分析",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item2.png",
          title: "读者画像分析",
          desc:
            "能够后台通过大数据分析读者的年龄层次分布性别比例以及其他画像属性分析",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item3.png",
          title: "图书馆实时动态",
          desc: "显示图书馆内实时的借书状态引导读者的借书氛围",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item4.png",
          title: "读者排行榜",
          desc: "通过后台数据分析对借阅量和活跃度实现实时动态排行榜",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item5.png",
          title: "图书馆实时动态",
          desc: "显示图书馆内实时的借书状态引导读者的借书氛围",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item6.png",
          title: "借还书实时统计",
          desc: "分析显示图书馆当天内实时借书数据和总借还统计",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item7.png",
          title: "借阅排行榜",
          desc: "通过后台对借阅数据排行分析动态实时计算出借阅排行榜",
        },
        {
          img: "https://image.bookgo.com.cn/bgOfficial/tofeel/tofeel-item8.png",
          title: "场馆人流热力图",
          desc: "通过对图书馆内人流密集度的分析得出热力分布图",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libTofeel.scss";
</style>
